import Modal from './browser';

import ModalBody from './components/dom/ModalBody';
import ModalHeader from './components/dom/ModalHeader';

Modal.Body = ModalBody;
Modal.Header = ModalHeader;

export default Modal;


//////////////////
// WEBPACK FOOTER
// ./~/tg-modal/es/index.js
// module id = 217
// module chunks = 3